import { Checkbox } from '@delmonicos/shared-design-system-react/src/components/checkbox/checkbox';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import * as css from './sortable-column-row.module.scss';

interface SortableColumnRowProps {
  columnId: string;
  label: string;
  isVisible: boolean;
  isLast: boolean;
  onVisibilityChange: (visible: boolean) => void;
}

export const SortableColumnRow = ({
  columnId,
  label,
  isVisible,
  isLast,
  onVisibilityChange,
}: SortableColumnRowProps): React.JSX.Element => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: columnId });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : undefined,
    zIndex: isDragging ? 1 : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Stack direction="column" gap={GapEnum.XS}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={GapEnum.M}>
          <Stack flex={1} className={css.label}>
            <Checkbox
              id={`column-visibility-${columnId}`}
              label={label}
              checked={isVisible}
              onChange={(event) => onVisibilityChange(event.target.checked)}
            />
          </Stack>
          <Icon
            name="menu-01"
            className={css.dragHandle}
            {...attributes}
            {...listeners}
          />
        </Stack>
        {!isLast && <Divider />}
      </Stack>
    </div>
  );
};
